import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import './CreditDetails.less';

export const CreditDetailsContainer = ({ children }) => (
    <section className={'CreditDetailsContainer RiskBasedCreditDetailsContainer'}>
        {children}
    </section>
);

CreditDetailsContainer.propTypes = {
    children: PropTypes.node, // CreditDetailsArticle
};

export default connect(null)(CreditDetailsContainer);